// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"fc0a389e","307":"0907c024","453":"dbf18621","551":"d41649a2"}[chunkId] + ".chunk.js";
};